import { render } from "./CreatorModalSide.vue?vue&type=template&id=44c9edea"
import script from "./CreatorModalSide.vue?vue&type=script&lang=js"
export * from "./CreatorModalSide.vue?vue&type=script&lang=js"

import "./CreatorModalSide.vue?vue&type=style&index=0&id=44c9edea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__